import { ReactNode } from 'react';

import { Icons } from '@cast/design-system';
import {
  EXPIRED_TRIAL_READONLY_TOOLTIP,
  useTrial,
} from '@cast/shared-trial-ui';

import { FEATURE_TO_TITLE } from 'hooks/dialogs/cluster/constants';

import {
  AgentSetupBlock,
  AgentSetupBlockProps,
} from './_components/AgentSetupBlock';
import { AgentSetupCompleteBlock } from './_components/AgentSetupCompleteBlock';
import FeatureLabel from './_components/FeatureLabel';

type SetupProps = Pick<
  AgentSetupBlockProps,
  | 'checked'
  | 'onChange'
  | 'hasBeenInstalled'
  | 'readonly'
  | 'readonlyTooltip'
  | 'showCheckbox'
  | 'labelChip'
> & {
  descriptionOverride?: ReactNode;
};

type CompleteProps = {
  checked?: boolean;
};

const heading = FEATURE_TO_TITLE.autoscaler;
const icon = <Icons.CastCostOptimization variant="preset" weight="light" />;

export const AgentAutoscalerSetup = ({
  labelChip,
  descriptionOverride,
  ...props
}: SetupProps) => {
  const { isPreTrial, isExpired } = useTrial();

  return (
    <AgentSetupBlock
      heading={heading}
      description={
        descriptionOverride ||
        'Optimize cluster performance and reduce costs with intelligent automated scaling.'
      }
      icon={icon}
      labelChip={
        labelChip ?? <FeatureLabel type={isPreTrial ? 'trial' : 'premium'} />
      }
      testId="agent-autoscaler"
      readonlyTooltip={isExpired ? EXPIRED_TRIAL_READONLY_TOOLTIP : undefined}
      {...props}
      {...(isExpired ? { checked: false, readonly: true } : {})}
    />
  );
};

export const AgentAutoscalerComplete = ({ checked }: CompleteProps) => {
  return (
    <AgentSetupCompleteBlock
      heading={heading}
      icon={icon}
      testId="agent-autoscaler-complete"
      checked={checked}
    />
  );
};
